import React, { FC, useEffect, useRef } from 'react';

import { Asset } from 'Shared/components';

import styles from './styles.module.css';

import { useFormikContext } from 'formik';
import { PurchaseFormValuesType } from '../../types';
import { usePurchaseContext } from 'QuoteApp/services/providers';

export const OchoPaymentMethod: FC = () => {
  const { setFieldValue, values } = useFormikContext<PurchaseFormValuesType>();
  const { submitBind } = usePurchaseContext();
  const isInitialized = useRef(false);

  useEffect(() => {
    if (isInitialized.current) return;

    const dummyToken = JSON.stringify({
      token: 'OCHO_DUMMY_TOKEN',
    });

    setFieldValue('adyenForm', {
      submit: () => {
        submitBind(values, dummyToken);
      },
    });

    isInitialized.current = true;
  }, [setFieldValue, submitBind, values]);

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <Asset variant="ocho" />
      </div>
      <h4>Agent Pay / ACH</h4>
      <p className={styles.disclaimer}>
        Ocho has partnered with Clearcover for Agent Pay. Ocho will collect
        payment from the customer according to their terms. Clearcover will
        deduct from Ocho’s account per the payment frequency selected for the
        policy.
      </p>
    </div>
  );
};
